/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".loading[_ngcontent-%COMP%]{opacity:.3;pointer-events:none}"];
export { styles as styles };
//# sourceMappingURL=videos-tile.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/home/videos-tile/videos-tile.component.scss.shim.ngstyle.js
// module id = 1641
// module chunks = 27 28 29